
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LoadingCircular extends Vue {
  @Prop({default: 70}) size!: number
  @Prop({default: 7}) width!: number
}
